interface IKeyCodeValue {
  normal: string;
  withShift: string;
}

export const keysMap: Record<KeyboardEvent['code'], IKeyCodeValue> = {
  Backquote: { normal: '`', withShift: '~' },
  Backslash: { normal: '\\', withShift: '|' },
  BracketLeft: { normal: '[', withShift: '{' },
  BracketRight: { normal: ']', withShift: '}' },
  Comma: { normal: ',', withShift: '<' },
  Digit0: { normal: '0', withShift: ')' },
  Digit1: { normal: '1', withShift: '!' },
  Digit2: { normal: '2', withShift: '@' },
  Digit3: { normal: '3', withShift: '#' },
  Digit4: { normal: '4', withShift: '$' },
  Digit5: { normal: '5', withShift: '%' },
  Digit6: { normal: '6', withShift: '^' },
  Digit7: { normal: '7', withShift: '&' },
  Digit8: { normal: '8', withShift: '*' },
  Digit9: { normal: '9', withShift: '(' },
  Equal: { normal: '=', withShift: '+' },
  KeyA: { normal: 'a', withShift: 'A' },
  KeyB: { normal: 'b', withShift: 'B' },
  KeyC: { normal: 'c', withShift: 'C' },
  KeyD: { normal: 'd', withShift: 'D' },
  KeyE: { normal: 'e', withShift: 'E' },
  KeyF: { normal: 'f', withShift: 'F' },
  KeyG: { normal: 'g', withShift: 'G' },
  KeyH: { normal: 'h', withShift: 'H' },
  KeyI: { normal: 'i', withShift: 'I' },
  KeyJ: { normal: 'j', withShift: 'J' },
  KeyK: { normal: 'k', withShift: 'K' },
  KeyL: { normal: 'l', withShift: 'L' },
  KeyM: { normal: 'm', withShift: 'M' },
  KeyN: { normal: 'n', withShift: 'N' },
  KeyO: { normal: 'o', withShift: 'O' },
  KeyP: { normal: 'p', withShift: 'P' },
  KeyQ: { normal: 'q', withShift: 'Q' },
  KeyR: { normal: 'r', withShift: 'R' },
  KeyS: { normal: 's', withShift: 'S' },
  KeyT: { normal: 't', withShift: 'T' },
  KeyU: { normal: 'u', withShift: 'U' },
  KeyV: { normal: 'v', withShift: 'V' },
  KeyW: { normal: 'w', withShift: 'W' },
  KeyX: { normal: 'x', withShift: 'X' },
  KeyY: { normal: 'y', withShift: 'Y' },
  KeyZ: { normal: 'z', withShift: 'Z' },
  Minus: { normal: '-', withShift: '_' },
  Period: { normal: '.', withShift: '>' },
  Quote: { normal: "'", withShift: '"' },
  Semicolon: { normal: ';', withShift: ':' },
  Slash: { normal: '/', withShift: '?' },
};
